export {default} from "./fourthSlide";
